import { useQuery } from '@tanstack/react-query';
import type { WorklistLoad } from '@k-management/shared';
import { useNavigate } from 'react-router';
import { ConfirmDialog } from '../../components/ConfirmDialog.js';
import { apiRequest } from '../../lib/api.js';
import { worklistKeys } from './treasury-ui.js';

/**
 * «Inizia ora» (3.00): right after a load, what it brought, how much the rules
 * settled already and what is left, with the way into Da sistemare.
 */
export function StartWorkDialog({
  loadKey,
  title,
  onClose,
}: {
  /** «banca:<id>», «carte:<id>» or «gestify:<id>». */
  loadKey: string;
  title: string;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  const loads = useQuery({
    // A load just made may be all settled by the rules already: all of them.
    queryKey: [...worklistKeys.all, 'loads', '', true],
    queryFn: () => apiRequest<WorklistLoad[]>('/treasury/worklist/loads?all=true'),
  });
  const load = loads.data?.find((item) => item.key === loadKey);
  return (
    <ConfirmDialog
      title={title}
      confirmLabel="Inizia ora"
      cancelLabel="Più tardi"
      busy={loads.isPending}
      error={loads.error?.message}
      onConfirm={() => {
        onClose();
        void navigate(`/tesoreria/da-sistemare?lotto=${encodeURIComponent(loadKey)}`);
      }}
      onCancel={onClose}
    >
      {load ? (
        <p>
          <strong>
            {load.total} {load.total === 1 ? 'nuovo' : 'nuovi'}
          </strong>
          {load.settled > 0 && `, ${load.settled} già sistemati dalle regole`}
          {load.todo > 0 ? (
            <>
              , <strong className="error">{load.todo} da fare</strong>.
            </>
          ) : (
            ': niente da fare.'
          )}
        </p>
      ) : (
        <p className="muted">Conteggio in corso…</p>
      )}
      <p className="muted small">
        Quello che non si può sistemare subito si mette in sospeso con il motivo e una data, così
        non si dimentica.
      </p>
    </ConfirmDialog>
  );
}
